var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "19.946%",
    y1: "72.147%",
    x2: "73.772%",
    y2: "18.374%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25B2F2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85D4F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "19.946%",
    y1: "72.147%",
    x2: "73.772%",
    y2: "18.374%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25B2F2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25B2F2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "7.395%",
    x2: "0%",
    y2: "100%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53C0F1",
    stopOpacity: 0.24,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F1FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.856.415L.398 25.328a.931.931 0 0 0 .214 1.319l18.244 12.768v-39z",
    fill: "url(#a)",
    transform: "matrix(-1 0 0 1 38 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.981 9.694v24.91L.612 26.647a.931.931 0 0 1-.214-1.319L11.98 9.694z",
    fill: "url(#b)",
    transform: "matrix(-1 0 0 1 38 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.814 25.329L19 .415v39l18.594-12.768a.925.925 0 0 0 .22-1.319z",
    fill: "url(#c)",
    transform: "matrix(-1 0 0 1 38 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingIcon);
export default __webpack_public_path__ + "static/media/pricing-icon.2813c0b991d44fbe809d86b4c05f690d.svg";
export { ForwardRef as ReactComponent };